<template>

  <v-app-bar height="90" app color="#fff" dense class="elevation-0 app__bar d-flex justify-space-between">
    <v-row class="top__menu__bar">
      <router-link :to="{name :'search-wizard'}">
        <v-col class="logo__box__wrap d-flex align-center">
          <div class="logo__box">
						<div>
							<v-img width="122px" src="@/assets/img/header_logo_sm.png"/>
							<span class="logo__box__title">Search System</span>
						</div>
						<div class="logo__text">
							<span>EGPO-SES</span>
							<span><b>S</b>earch and <b>E</b>-service <b>S</b>ystem</span>
						</div>
          </div>

          <v-spacer class="hidden_lr10 logo__box__title__spacer"></v-spacer>
          <!-- <span class="header__title" v-html="$t('view.HEADER.System_title')"> -->
          <span class="header__title">
            <span class="logo__icon"><v-img width="60" max-width="60" src="@/assets/img/logo_icon.png"/></span>
            <v-spacer class="hidden_lr5"></v-spacer>
						<div class="logo__text">
							<span>EGPO-SES</span>
							<span><b>S</b>earch and <b>E</b>-service <b>S</b>ystem</span>
						</div>
          </span>
        </v-col>
      </router-link>

      <v-col class="d-flex top__menu align-center" :class="{actv : isNav}">
        <v-menu
					open-on-hover
          transition="slide-y-transition"
          bottom
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="#222"
              v-bind="attrs"
              v-on="on"
              text
              class="text-capitalize"
              v-html="$t('view.MENU.Search')"
              >
              Quick Search
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-for="(item, index) in menu.search" :key="index">
              <v-list-item-title @click="redirectTo(item.name, item.params)">{{ $t('view.MENU.' + item.title) }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <!-- <v-menu
          transition="slide-y-transition"
          bottom
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="#222"
              text
              v-bind="attrs"
              v-on="on"
              class="text-capitalize"
              v-html="$t('view.MENU.Advanced Search')"
              >
              Advanced Search
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-for="(item, index) in menu.advancedSearch" :key="index">
              <v-list-item-title @click="redirectTo(item.name, item.params)">{{ $t('view.MENU.' + item.title) }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu> -->

        <v-menu
					open-on-hover
          transition="slide-y-transition"
          bottom
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="#222"
              text
              v-bind="attrs"
              v-on="on"
              class="text-capitalize"
              v-html="$t('view.MENU.My')"
              >
              User Guide
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-for="(item, index) in menu.my" :key="index">
              <v-list-item-title @click="redirectTo(item.name, item.params)">{{ $t('view.MENU.' + item.title) }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-menu
					open-on-hover
          transition="slide-y-transition"
          bottom
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="#222"
              text
              v-bind="attrs"
              v-on="on"
              class="text-capitalize"
              v-html="$t('view.MENU.User Guide')"
              >
              User Guide
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-for="(item, index) in menu.userGuide" :key="index">
              <v-list-item-title @click="redirectToGuide(item.name)">{{ $t('view.MENU.' + item.title) }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>


        <!--
        <v-btn v-if="this.user"
          color="#222"
          text
          class="text-capitalize"
          @click="redirectTo(menu.bookmark.name)"
          >
          {{ $t('view.MENU.' + menu.bookmark.title) }}
        </v-btn>

        <v-btn v-if="this.user"
          color="#222"
          text
          class="text-capitalize"
          @click="redirectTo(menu.memo.name)"
          >
          {{ $t('view.MENU.' + menu.memo.title) }}
        </v-btn>

        <v-btn
          color="#222"
          text
          class="text-capitalize"
          @click="redirectTo(menu.query.name)"
          >
          {{ $t('view.MENU.' + menu.query.title) }}
        </v-btn>
        -->
      </v-col> 

      <v-col class="auth__menu d-flex align-center" :class="{actv : isNav}">
        <v-spacer></v-spacer>
        <div class="lang__selector">
          <span v-html="$t('view.TERM.ENGLISH')">ENGLISH</span>
          <v-spacer class="hidden_lr5"></v-spacer>
          <v-switch
            v-model="rtl"
            color="red"
            value="red"
            class=""
            hide-details
            @change="fnSetLocale()"
          ></v-switch>

          <v-spacer class="hidden_lr5"></v-spacer>
          <span v-html="$t('view.TERM.ARABIC')">ARABIC</span>
        </div>

        <v-btn v-if="!this.user"
          outlined
          rounded
          dense
          text
          small
          height="35"
          color="#222"
          class="text-capitalize exm__sign__button"
          @click="redirectTo(menu.signin.name)"
        >
        <v-icon
        small
        class="mr--4"
        >mdi-account</v-icon>{{ $t('view.MENU.' + menu.signin.title) }}</v-btn>
        <v-btn v-else
          outlined
          rounded
          dense
          text
          small
          height="35"
          color="#222"
          class="text-capitalize exm__sign__button"
          @click="signout()"
        >
        <v-icon
        small
        class="mr--4"
        >mdi-account</v-icon>{{ $t('view.MENU.' + menu.signout.title) }}</v-btn>
      </v-col>

      <v-btn class="hmb__menu" icon color="#222" :class="{actv : isNav}" @click="isNav = !isNav, makskevent(isNav)">
        <v-icon v-if="isNav == false">mdi-menu</v-icon>
        <v-icon v-else>mdi-close</v-icon>
      </v-btn>
    </v-row>
    <div class="maskDim" :class="{actv : isNav}"></div>
  </v-app-bar>
</template>

<script>
import { SEARCH_DOMAIN_TYPE_CODE } from '../../models/code';
export default {
  name: 'Appbar',
  data: () => ({
    rtl: false,
    isNav : false,
    // menu: {
    // }
  }),
  created () {
    this.rtl = this.$i18n.locale === 'ar';
    // this.menu = {
    //   search: [
    //     { title: 'Search Wizard', name: 'search-wizard', params: {} },
    //     { title: 'Keyword Search', name: 'keyword-search', params: {} },
    //     // { title: 'Keyword Search', name: 'keyword-search', params: {} }
    //     { title: 'Advanced Search', name: 'advanced-search', params: { domain: SEARCH_DOMAIN_TYPE_CODE.all } },
    //   ],
    //   my: this.user ? [ 
    //       { title: 'Bookmark', name: 'bookmark' },
    //       { title: 'My Memo', name: 'memo' },
    //       { title: 'My Query', name: 'query' },
    //     ] : [ 
    //       { title: 'My Query', name: 'query' },
    //   ] ,
    //   userGuide: [
    //     { title: 'User Guide', name: "guide" },
    //     { title: 'FAQs', name: "faqs" }
    //   ],
    //   /*
    //   quickSearch: [
    //     { title: 'Search Wizard', name: 'search-wizard', params: {} },
    //     { title: 'Keyword Search', name: 'keyword-search', params: {} }
    //   ],
    //   advancedSearch: [
    //     { title: 'Patent/Utility Model', name: 'advanced-search', params: { domain: 'patent-utility-model' } },
    //     // { title: 'intergrated Circuit Topography', name: 'advanced-search', params: { domain: 'ic-topology' } },
    //     // { title: 'Oversea', name: 'advanced-search', params: { domain: 'oversea' } }
    //   ],
    //   userGuide: [
    //     { title: 'User Guide', name: "guide" },
    //     { title: 'FAQs', name: "faqs" }
    //   ],
    //   bookmark: { title: 'Bookmark', name: 'bookmark' },
    //   memo: { title: 'My Memo', name: 'memo' },
    //   query: { title: 'My Query', name: 'query' },
    //   */
    //   signin: { title: 'Examiner Sign in', name: 'signin' },
    //   signout: { title: 'Examiner Sign out' },
    // }
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
    menu() {
      return {
        search: [
          { title: 'Search Wizard', name: 'search-wizard', params: {} },
          { title: 'Keyword Search', name: 'keyword-search', params: {} },
          // { title: 'Keyword Search', name: 'keyword-search', params: {} }
          { title: 'Advanced Search', name: 'advanced-search', params: { domain: SEARCH_DOMAIN_TYPE_CODE.all } },
        ],
        my: this.user ? [ 
            { title: 'Bookmark', name: 'bookmark' },
            { title: 'My Memo', name: 'memo' },
            { title: 'My Query', name: 'query' },
          ] : [ 
            { title: 'My Query', name: 'query' },
        ] ,
        userGuide: [
          { title: 'User Guide', name: "guide" },
          { title: 'FAQs', name: "faqs" }
        ],
        /*
        quickSearch: [
          { title: 'Search Wizard', name: 'search-wizard', params: {} },
          { title: 'Keyword Search', name: 'keyword-search', params: {} }
        ],
        advancedSearch: [
          { title: 'Patent/Utility Model', name: 'advanced-search', params: { domain: 'patent-utility-model' } },
          // { title: 'intergrated Circuit Topography', name: 'advanced-search', params: { domain: 'ic-topology' } },
          // { title: 'Oversea', name: 'advanced-search', params: { domain: 'oversea' } }
        ],
        userGuide: [
          { title: 'User Guide', name: "guide" },
          { title: 'FAQs', name: "faqs" }
        ],
        bookmark: { title: 'Bookmark', name: 'bookmark' },
        memo: { title: 'My Memo', name: 'memo' },
        query: { title: 'My Query', name: 'query' },
        */
        signin: { title: 'Examiner Sign in', name: 'signin' },
        signout: { title: 'Examiner Sign out' },
      }
    }
  },
  methods : {
    redirectTo(name, params) {
      this.isNav = false;
      this.makskevent(false)
      this.redirect({name, params})
    },
    redirectToGuide(name) {
      if(name === 'faqs') {
        window.open(this.config.FAQS_URL, '_blank');
      } else {
        this.$store.dispatch('auth/getUserGuideUrl').then((url) => {
          const fileKey = this.$i18n.locale === 'en' ? url.user_guide_file_key_en : url.user_guide_file_key_ar;
          this.download(this.config.DOWNLOAD_URL + fileKey);
        });
      }
    },
    signout() {
      this.$store.dispatch('auth/signout').then(() => {
        this.redirect({name: 'keyword-search'})
      });
    },
    makskevent (isNav){
      if(isNav){
        document.querySelector("body").classList.add('ovf-h');
      }else{
        document.querySelector("body").classList.remove('ovf-h');
      }

    },
    fnSetLocale () {
      if (this.$vuetify.rtl) {
        this.$vuetify.rtl = false
        if (this.$i18n.locale !== 'en') {
          this.$cookies.set('lang', 'en', -1);
          this.$i18n.locale = 'en';
        }
      } else {
        this.$vuetify.rtl = true
        if (this.$i18n.locale !== 'ar') {
          this.$cookies.set('lang', 'ar', -1);
          this.$i18n.locale = 'ar';
        }
      }
    }
  }
}
</script>